import React, { useState } from 'react'
import companyInfUser from "../../images/viewProfileContact_img.svg"
import { isEmpty } from 'lodash';
import defaultValues from '../../constant/defaultValues';
import CheckBox from '../CheckBox';
import { useAuth } from '../../AuthProvider';

function ContactDetail(props) {

  const contact = props.data;
  const { IMAGE_PATH } = defaultValues;

  const { isEndUser, isSuperAdmin, isDemoUser } = useAuth();

  const compRepImp =
    contact && contact.company_representative_image
      ? IMAGE_PATH.BASE_URL + "/company_logo/" + contact.company_representative_image
      : (contact && contact.image ? IMAGE_PATH.BASE_URL + "/member_contacts/" + contact.image : companyInfUser);



  return (

    <div className='contact-person-wrape'>

      <h3 className=''>
        {props.title}

        { /* {(isSuperAdmin || isDemoUser || (isEndUser && props.isDownloadable)) && props.title === 'Company Representative' && contact && 
        <CheckBox checked={props.isChecked} onChange={props.onChange} value={contact.id} name='company_representative'/>
        }

        {(isSuperAdmin || isDemoUser || (isEndUser && props.isDownloadable)) && props.title != 'Company Representative' && contact && 
        <CheckBox checked={props.isChecked} onChange={props.onChange} value={contact.id} name='contact_person'/>
        } */}
      </h3>

      {
        contact &&
        <div className='row'>
          <div className='col-xxl-2 col-xl-2 col-lg-2 col-md-4 pe-1'>
            <div className='person-tumb'>
              <img src={compRepImp} alt="" className={`${contact && contact.company_representative_image ? `img` : (contact && contact.image ? `img` : ``)}`} />
            </div>
          </div>

          <div className='col-xxl-10 col-xl-10 col-lg-10 col-md-8'>
            <div className='row'>
              <div className='col-xxl-12  col-xl-12  col-lg-12'>
                <div className=' profile-details'>
                  <div className='row'>
                    <div className='col-xxl-3 col-xl-3 col-lg-6 col-md-12'>
                      <p>
                        <span>First Name </span>
                        {contact.salutation} {contact.first_name}
                      </p>
                    </div>
                    <div className='col-xxl-4 col-xl-4 col-lg-6 col-md-12'>
                      <p>
                        <span>Last Name</span>
                        {(!isEmpty(contact.last_name)) ? contact.last_name : '-'}
                      </p>
                    </div>

                    <div className='col-xxl-5 col-xl-5 col-lg-6 col-md-12'>
                      <p>
                        <span>Email</span>
                        {(!isEmpty(contact.email)) ? contact.email.includes('**') ? contact.email : <a href={`mailto:${contact.email}`}>{contact.email}</a> : '-'}
                      </p>
                    </div>

                    <div className='col-xxl-3 col-xl-3 col-lg-6 col-md-12'>
                      <p>
                        <span>Designation</span>
                        {(!isEmpty(contact.designation)) ? contact.designation : '-'}
                      </p>
                    </div>

                    <div className='col-xxl-4 col-xl-4 col-lg-6 col-md-12'>
                      <p>
                        <span>{!props.isStaffInfo ? 'Contact' : 'Mobile'}</span>
                        {(!isEmpty(contact.phone)) ? (contact.phone === "**********") ? contact.phone : <a href={`tel:${contact.phone}`}>{contact.phone}</a> : '-'}
                      </p>
                    </div>
                    {!props.isStaffInfo && <div className='col-xxl-4 col-xl-4 col-lg-6 col-md-12'>
                      <p>
                        <span>Mobile</span>
                        {(!isEmpty(contact.mobile)) ? <a href={`tel:${contact.mobile}`}>{contact.mobile}</a> : '-'}
                      </p>
                    </div>}

                    {!props.isStaffInfo && <div className='col-xxl-3 col-xl-3 col-lg-6 col-md-12'>
                      <p>
                        <span>Country</span>
                        {(!isEmpty(contact.country)) ? contact.country : '-'}
                      </p>
                    </div>
                    }
                    {
                      !props.isStaffInfo && <div className='col-xxl-4 col-xl-4 col-lg-6 col-md-12'>
                        <p>
                          <span>City</span>
                          {(!isEmpty(contact.city)) ? contact.city : '-'}
                        </p>
                      </div>
                    }

                  </div>
                </div>


              </div>


            </div>


          </div>


        </div>


      }

    </div >

  )
}

export default ContactDetail;